module.exports = __webpack_public_path__ + "static/img/glxxdt.f9e73f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/linshi/glxxdt.png
// module id = 4KMA
// module chunks = 44